import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import Popup from 'Components/Popup'
import React, { useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { helpSubmission } from '../../../gql/helpSubmissions'
import MessageSentPopup from './messageSentPopup'
import styles from './styles'

const HelpSubmissionPopup = ({ classes, onCancel, isOpen }) => {
  const [isInProgress, setIsInProgress] = useState(false)
  const [validationError, setValidationError] = useState(false)
  const [isSuccessPopupShow, setIsSuccessPopupShow] = useState(false)

  const ref = useRef(null)
  const { campaignId } = useParams()

  const onConfirm = async () => {
    setIsInProgress(true)
    const response = await helpSubmission({
      campaignId: campaignId,
      clientMessage: ref.current.value,
    })
    await response.json()
    setIsInProgress(false)
    setIsSuccessPopupShow(true)
  }

  const validator = () => {
    setValidationError()
    if (ref.current.value.length >= 2000) {
      setValidationError('Message should be shorter than 2000 characters')
    }
    if (ref.current.value.length <= 30) {
      setValidationError('Message should be longer than 30 characters')
    }
  }

  if (!isOpen) {
    return null
  }

  if (isSuccessPopupShow) {
    return <MessageSentPopup onClose={onCancel} />
  }
  return (
    <Popup
      title="We're here to help!"
      onCancel={onCancel}
      canBeClose={!isInProgress}
      modalClassName={classes.submissionPopup}
      body={
        <div>
          <div className={classes.infoBlock}>
            <div className={classes.content}>
              If you are unable to provide this data or have any questions about
              the process, we'll work together to find a solution.
            </div>
            <div className={classes.content}>
              Submit a couple of sentences below and we'll get back to you
              shortly.
            </div>
            <textarea
              className={classes.textArea}
              rows="10"
              ref={ref}
              placeholder="Your message here..."
              onChange={validator}
            />
          </div>
          {validationError ? (
            <div className={classes.error}>{validationError}</div>
          ) : null}
        </div>
      }
      footer={
        <div>
          <Button
            className={cn(classes.button, classes.filledButton)}
            onClick={onConfirm}
            variant="contained"
            disabled={
              isInProgress ||
              validationError ||
              !ref.current ||
              ref.current.value.length <= 30
            }
          >
            {isInProgress ? <CircularProgress size={20} /> : null} Confirm
          </Button>
          <Button
            className={classes.button}
            variant="outlined"
            onClick={onCancel}
            disabled={isInProgress}
          >
            Cancel
          </Button>
        </div>
      }
    />
  )
}

export default withStyles(styles)(HelpSubmissionPopup)
